import type { FormikValidationResult } from 'types';

export const hasErrors = (errors: Record<string, FormikValidationResult>): boolean => {
    return Object.values(errors).some(Boolean);
};
